<div class="dropdown">
  <div class="dropdown-item">
    <div class="icon-text name-field">
      <mat-icon class="icon">account_circle</mat-icon>
      {{ user.fullName }}
    </div>
    <div class="icon-text">
      <mat-icon class="icon">mail_outline</mat-icon>
      @if (user.email) {
        {{ user.email }}
      } @else {
        {{ 'general.navbar.user.noEmail' | translate }}
      }
    </div>
  </div>
  <mat-divider/>
  <div class="dropdown-item icon-text" matTooltip="{{ getRoles() }}"
       [matTooltipClass]="'tooltip'"
       [matTooltipPosition]="'before'">
    <mat-icon class="icon">supervisor_account</mat-icon>
    {{ getRolesCount() }} {{ 'general.navbar.user.role' | translate }}
  </div>
  <mat-divider/>
  <!-- need to be external call -->
  <div class="dropdown-item orange icon-text">
    <mat-icon class="icon">logout</mat-icon>
    <a style="text-decoration: none; cursor: pointer" (click)="logout()">
      {{ 'general.navbar.user.logout' | translate }}
    </a>
  </div>
</div>
